<template>
    <div name="navigation" :class="{'navigation': true, 'fixed': isScrolled}" >
        <div class="header">
            <a href="https://soldoc.co.kr/partners" class="logo-wrap">
                <img src="../../assets/partners_pc/logo_white.png" alt="soldoc+" class="logo" />
                <img src="../../assets/partners_pc/logo.png" alt="soldoc+" class="logo-blue" />
            </a>
            <div class="wrapper">
                <a
                    href="https://partner.soldoc.co.kr/"
                    class="btn btn-join"
                    target="_blank"
                    title="새 창 열림"
                    ><span>솔루션 가입하기</span></a
                >
            </div>
        </div>       
    </div>
</template>

<script>
export default {
    name: 'navigation',
    data() {
    return {
        isScrolled: false
        };
    },
    mounted: function()
    {
        $('html').animate({
            scrollTop: 0
        }, 100);
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        goBarosoldoc: function()
        {
            var element = document.getElementById("mainbanner");
            if (element) {
            var rect = element.getBoundingClientRect();
            var offsetTop = rect.top + window.scrollY;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
            }
        },
        handleScroll() {
            var mainHeight = window.innerHeight - 200;
            var elementHeight = window.innerHeight * 4;
            if (window.scrollY >= 0 && window.scrollY <= mainHeight) {
                document.querySelector('.navigation').style.position = 'fixed';
            }
            if (window.scrollY >= elementHeight) {
                this.isScrolled = true;
            } else {
                this.isScrolled = false;
            }
        },
    }
}
</script>

<style scoped>
    .navigation {    
        position: relative;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 64px;
        text-align: center;
        z-index: 200;
    }
    .navigation.fadeout {
        animation: fadeOutUp 1s;
    }
    .navigation.fixed {
        position: fixed;
        height: 64px;
        background:#fff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
        animation: fadeInUp 1s;
    }
    .navigation.fixed .header {
        height: 64px;
        margin-top: 0;
    }
    .navigation.fixed .logo {
        display: none;
    }
    .navigation.fixed .logo-blue {
        display: block;
    }
    .navigation.fixed .btn-join {
        background: #fff;
        border: 1px solid #008DEF;
        color: #008DEF;     
    }
    .navigation.fixed .btn-join:hover {
        background: #008DEF;
        color: #fff;     
    }
    .logo-blue {
        display: none;
    }
    .header {
        position: sticky;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 64px;
        min-width: 960px;
        max-width: 1240px;
        padding: 0 20px;
    }
    .navigation .btn-join {
        display: inline-flex;
        min-width: 127px;
        height: 42px;
        padding: 4px 19px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background: #008DEF;
        font-size: 16px;
        font-weight: 600;
        line-height: 34px;
        text-align: center;
        color: #fff;
    }
    .navigation .btn-join:hover {
        background: #fff;
        color: #008DEF;    
    }
    .navigation .btn-join:focus {
        box-shadow: none;
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, -50%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }
    @keyframes fadeOutUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 0%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, -50%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_partners/Navigation.vue